import React, { useEffect, useState } from 'react';
import Main from '../../Main';
import { Col, Dropdown, Row } from 'react-bootstrap';
import columnFilter from '../../../assets/images/CustomerManagement/columnFilter.svg'
import valueFilter from '../../../assets/images/CustomerManagement/valueFilter.svg'
import '../../../assets/css/dashboard.scss'
import '../../../assets/css/customermanagement.scss'
import 'react-datepicker/dist/react-datepicker.css';
import SbCancelBtn, { SbAddBtn, SbFilterBtn } from '../../Buttons/Buttons';
import Select from 'react-select';
import LeaveApprovalTable from './LeaveApprovalTable';
import AddLeaveApproval from './AddLeaveApproval';
import Download from '../../MainSection/Download/Download';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loadSettingsLeaveApprovalData, loadSettingsSingleLeaveApprovalData, postLeaveApprovalDatas } from '../../../redux/action';
import LeaveApprovalColumnFilter from './LeaveApprovalColumnFilter';
import * as HeaderAuthentication from '../../HeaderAuthentication'
import { ADDED_BY_ID } from '../../../Constants';
import LeaveApprovalValueFilter from './LeaveApprovalValueFilter';

const statusOptions = [
    { value: 52, label: "Active" },
    { value: 53, label: "Inactive" }
]

const LeaveApproval = () => {
    let dispatch = useDispatch();
    const { id: userRefId } = useParams();

    const { leaveApprovalData } = useSelector((state) => state.data);
    const { singleLeaveApprovalData } = useSelector((state) => state.data);

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [showColumnFilterModal, setShowColumnFilterModal] = useState(false);
    const [showValueFilterModal, setShowValueFilterModal] = useState(false);
    const [showCustomerViewDetails, setShowCustomerViewDetails] = useState(false);
    const [businessUnitModal, setBusinessUnitModal] = useState(false);
    const [branchPlantModal, setBranchPlantModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [leaveApprovalId, setLeaveApprovalId] = useState("")
    const [selectedColumns, setSelectedColumns] = useState([
        "LEAVE LEVEL", "TITLE", "DEPARTMENT", "LEAVE ORDER",
        "STATUS", "ACTION"
    ]);
    const [selectedStatusID, setSelectedStatusID] = useState(null);
    const [dataLoading, setDataLoading] = useState(false);

    const handleStatusSelection = (selectedOption) => {
        if (selectedOption) {
            const statusID = selectedOption.value;  // Extract StatusID (assuming 'value' is the StatusID)
            setSelectedStatusID(statusID);  // Store StatusID in state
            leaveApproval(statusID);  // Call API with both StatusID and current RoleID
        }
    };

    useEffect(() => {
        if (userRefId) {
            dispatch(loadSettingsSingleLeaveApprovalData(setDataLoading, userRefId));
        } else {
            leaveApproval();
        }
    }, [userRefId]);

    const leaveApproval = (statusID) => {
        dispatch(loadSettingsLeaveApprovalData(setLoading, statusID));
    }

    useEffect(() => {
        leaveApproval();
    }, []);

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };
    const handleOpenModal = (leaveApprovalID) => {
        setIsModalOpen(true);
        if (leaveApprovalID) {
            dispatch(loadSettingsSingleLeaveApprovalData(setDataLoading, leaveApprovalID));
            setLeaveApprovalId(leaveApprovalID);
        } else {
            setLeaveApprovalId("");
        }
    };

    const handleCloseModal = () => {
        setLeaveApprovalId("");
        dispatch(loadSettingsSingleLeaveApprovalData(setDataLoading, null));
        setIsModalOpen(false);
    };
    const handleOpenColumnFilterModal = () => {
        setShowFilterMenu(false);
        setShowColumnFilterModal(true);
    };

    const handleCloseColumnFilterModal = () => {
        setShowColumnFilterModal(false);
    };
    const handleOpenValueFilterModal = () => {
        setShowFilterMenu(false);
        setShowValueFilterModal(true);
    };

    const handleCloseValueFilterModal = () => {
        setShowValueFilterModal(false);
    };

    const handleViewDetails = () => {
        setShowCustomerViewDetails(!showCustomerViewDetails);
    }
    const navigate = useNavigate();
    const handleBack = () => {
        navigate(-1);
    };

    const handleColumnSelectionChange = (updatedSelectedColumns) => {
        setSelectedColumns(updatedSelectedColumns); // Update the selected columns
    };

    const handleStatusChange = (customer, statusLabel) => {
        const statusID = statusLabel === "Active" ? 52 : 53; // 52 for Active, 53 for Inactive

        // console.log(customer, 'customer')
        const data = {
            LeaveApprovalID: customer.LeaveApprovalID,
            LevelID: customer.LeaveApprovalID,
            Title: customer.LeavesApprovalTitle,
            DepartmentID: customer.LeavesApprovalDepartmentID,
            Order: customer.LeavesApprovalOrder,
            Condition: customer.LeavesApprovalCondition,
            StatusID: statusID,
            AddedByID: ADDED_BY_ID
        }

        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data),
        };

        // Dispatch the action to update the department status
        dispatch(postLeaveApprovalDatas(requestOption, handleCloseModal, leaveApproval, customer.LeaveApprovalID));
        // console.log(data, 'data'); // For debugging purposes
    };

    const handleClearFilters = () => {
        setSelectedStatusID(null);
        leaveApproval();
    }

    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showBackButton={true}
                        moduleName="Settings / Leave Approval"
                        onBackClick={handleBack}
                    />
                </div>
                <div className='customermanagement-content-container'>
                    <div className="customermanagement-content">
                        <Row className='customermanagement-btns-container'>
                            <Col md={3} className='customermanagement-backbtn-div'>
                                {/* <img src={backbtn} alt="" /> */}
                                <span>Leave Approval</span>
                            </Col>
                            <Col md={9} className='customermanagement-search-filter'>
                                <div className='customermanagement-header-btns filter-btn'>
                                    <SbFilterBtn btnName="Filters" onClickEffect={toggleFilterMenu} />
                                    {showFilterMenu && (
                                        <Dropdown.Menu show className='filter-dropdown-options'>
                                            <Dropdown.Item onClick={handleOpenColumnFilterModal}>
                                                <img src={columnFilter} alt="" />&nbsp;&nbsp;
                                                Column Filter
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={handleOpenValueFilterModal}>
                                                <img src={valueFilter} alt="" />&nbsp;&nbsp;
                                                Value Filter
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    )}
                                </div>
                                <Col md={3} className='filters-col'>
                                    <Select
                                        className="react-select-container complaint-status-select"
                                        classNamePrefix="react-select"
                                        placeholder="Search Status"
                                        options={statusOptions}
                                        style={{ width: "100%" }}
                                        value={selectedStatusID ? statusOptions.find(status => status.value === selectedStatusID) : null}
                                        onChange={(selectedOption) => handleStatusSelection(selectedOption)}
                                    />
                                </Col>
                                <SbCancelBtn btnName="Clear" onClickEffect={handleClearFilters} />
                                <SbAddBtn btnName="Add" onClickEffect={() => { handleOpenModal("") }} />
                            </Col>
                        </Row>
                        <div className='customermanagement-table-div'>
                            <LeaveApprovalTable
                                handleOpenModal={handleOpenModal}
                                handleViewDetails={handleViewDetails}
                                loading={loading}
                                leaveApprovalData={leaveApprovalData}
                                selectedColumns={selectedColumns}
                                handleStatusChange={handleStatusChange}
                                singleLeaveApprovalData={singleLeaveApprovalData}
                                userRefId={userRefId}
                            />
                        </div>
                    </div>
                </div>
            </Main>
            {
                isModalOpen && <AddLeaveApproval
                    open={isModalOpen}
                    handleCloseModal={handleCloseModal}
                    singleLeaveApprovalData={singleLeaveApprovalData}
                    leaveApprovalId={leaveApprovalId}
                    leaveApproval={leaveApproval}
                    dataLoading={dataLoading}
                />
            }
            {showColumnFilterModal && (
                <LeaveApprovalColumnFilter
                    showColumnFilterModal={showColumnFilterModal}
                    handleCloseColumnFilterModal={handleCloseColumnFilterModal}
                    selectedColumns={selectedColumns}
                    handleSaveColumns={handleColumnSelectionChange}
                />
            )}
            {showValueFilterModal && (
                <LeaveApprovalValueFilter
                    showValueFilterModal={showValueFilterModal}
                    handleCloseValueFilterModal={handleCloseValueFilterModal}
                />
            )}
            {/* {showCustomerViewDetails && (
                <CustomerViewDetails
                    showCustomerViewDetails={showCustomerViewDetails}
                    handleCloseViewDetails={handleCloseViewDetails}
                />
            )} */}
        </div >
    );
};

export default LeaveApproval;